/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Injury_Since_InvalidInputs */

const en_us2_injury_since_invalid = /** @type {(inputs: Injury_Since_InvalidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`That is not a date we can read.`)
};

const pt_br2_injury_since_invalid = /** @type {(inputs: Injury_Since_InvalidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Não conseguimos entender essa data.`)
};

const es_419_injury_since_invalid = /** @type {(inputs: Injury_Since_InvalidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No pudimos entender esa fecha.`)
};

const pt_pt2_injury_since_invalid = /** @type {(inputs: Injury_Since_InvalidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Não conseguimos ler essa data.`)
};

const fr_fr2_injury_since_invalid = /** @type {(inputs: Injury_Since_InvalidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cette date est illisible pour nous.`)
};

const de_de2_injury_since_invalid = /** @type {(inputs: Injury_Since_InvalidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dieses Datum können wir nicht lesen.`)
};

const it_it2_injury_since_invalid = /** @type {(inputs: Injury_Since_InvalidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Non riusciamo a leggere questa data.`)
};

/**
* | output |
* | --- |
* | "That is not a date we can read." |
*
* @param {Injury_Since_InvalidInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const injury_since_invalid = /** @type {((inputs?: Injury_Since_InvalidInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Injury_Since_InvalidInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_injury_since_invalid(inputs)
	if (locale === "es-419") return es_419_injury_since_invalid(inputs)
	if (locale === "pt-PT") return pt_pt2_injury_since_invalid(inputs)
	if (locale === "fr-FR") return fr_fr2_injury_since_invalid(inputs)
	if (locale === "de-DE") return de_de2_injury_since_invalid(inputs)
	if (locale === "it-IT") return it_it2_injury_since_invalid(inputs)
	return en_us2_injury_since_invalid(inputs)
});
export { injury_since_invalid as "injury.since_invalid" }